import Reveal from "./Reveal";

/** Edge-to-edge photographic page hero. */
export const PageHero = ({ image, alt, eyebrow, title, subtitle, children, align = "left" }) => (
  <section className="relative isolate overflow-hidden bg-navy">
    {/* Pages without a photographic hero must not emit a src-less <img>. */}
    {image && (
      <img
        src={image}
        alt={alt}
        width={1264}
        height={848}
        className="absolute inset-0 h-full w-full object-cover"
      />
    )}
    <div className="absolute inset-0 hero-scrim" />
    <div
      className={`relative mx-auto max-w-7xl px-5 lg:px-10 pt-28 pb-16 lg:pt-44 lg:pb-28 ${
        align === "center" ? "text-center" : ""
      }`}
    >
      <Reveal className={align === "center" ? "mx-auto max-w-3xl" : "max-w-2xl"}>
        {eyebrow && <p className="eyebrow text-lake">{eyebrow}</p>}
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-white">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-base md:text-lg text-white/85 leading-relaxed">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
